import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "secret-key",
  "use": "secret-key-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"secret-key\"><defs><style>#secret-key .cls-1{fill:none;}#secret-key .cls-2{fill:#4238C9;}</style></defs><rect class=\"cls-1\" width=\"24\" height=\"24\" /><path class=\"cls-2\" d=\"M10.31,11.57l7.94-7.94,2.12,2.12L19,7.16l2.12,2.12-3.53,3.54L15.43,10.7l-3,3a5,5,0,1,1-2.13-2.12Zm-.9,5.84a2,2,0,1,0-2.8,0A2,2,0,0,0,9.41,17.41Z\" transform=\"translate(0 0)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol